import React, { useEffect, useState } from "react";
import { FileUploadOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";

import { MTable } from "../v3";
import { stockHistoryColumnHeaders } from "../../pages/stock/constants";
import { StockService } from "../../services";

export const StockHistory = ({ id }) => {
  const [yardItems, setYardItems] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [paginationState, setPaginationState] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (filters) => {
    try {
      setLoading(true);
      const yardDetails = await StockService.getYard(Number(id));
      setYardItems(yardDetails.stockItems);
      setLoading(false);
    } catch (error) {
      console.error(`🚀 ~ fetchData ~ error:`, error);
      toast.error("Error fetching data");
    }
  };

  const handleSearchChange = (searchValue) => {
    setSearchText(searchValue);
    // fetch data
  };

  const handleExportClick = () => {
    // Implement export functionality here
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    // fetch data
  };

  const onStockClick = (stock) => {
    // TODO: Implement stock click functionality
    // navigate(`/stocks/${stock.id}`);
  };

  // hard coded datas from constants file
  const rows = yardItems.map((item, index) => {
    return {
      sl: index + 1,
      id: index + 1,
      itemName: item.itemName,
      count: item.count,
    };
  });
  return (
    <MTable
      placeholder="search stocks"
      searchText={searchText}
      onSearchChange={handleSearchChange}
      showSearchBar
      // Export Button data
      buttonText="Export"
      buttonIcon={FileUploadOutlined}
      onExportClick={handleExportClick}
      showExportButton
      // Table data
      columnHeaders={stockHistoryColumnHeaders}
      tableRows={rows}
      rowCount={rows.length}
      loading={loading}
      paginationModel={paginationState}
      onPaginationChange={handlePaginationChange}
      onRowClick={onStockClick}
    />
  );
};
